import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavPillsComponent } from './nav-pills/nav-pills.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbModule, NgbNavConfig, NgbNavModule, NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from '../app-routing.module';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { FilterComponent } from './filter/filter.component';
import { RouterModule } from '@angular/router';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { GoogleMapsModule } from '@angular/google-maps';
 
@NgModule({
  declarations: [
    NavPillsComponent,
    FilterComponent,
    DatePickerComponent,
   ],
  imports: [
    CommonModule,
    FormsModule,
    NgbNavModule,
    SlickCarouselModule,
    CarouselModule,
    NgbDatepickerModule,
    BsDatepickerModule,
    NgSelectModule,
     BreadcrumbModule,
     RouterModule,
     NgbTooltipModule,
     NgbModule,
     ReactiveFormsModule,
     GoogleMapsModule

   ],
  exports: [
    FilterComponent,
    FormsModule ,
    NgbNavModule,
    SlickCarouselModule,
    CarouselModule,
    NgbDatepickerModule,
    BsDatepickerModule,
    NgSelectModule,
    BreadcrumbModule,
     CarouselModule,
     RouterModule,
     NgbTooltipModule,
     GoogleMapsModule,
     ReactiveFormsModule
  ],
  providers: [NgbNavConfig],
})
export class SharedModule { }
